import React from 'react';

import JobDetailScene from 'views/scenes/job_board/JobDetail';

const JobDetail = (props) => {
  return (
    <>
      <JobDetailScene

      />
    </>
  );
};

JobDetail.propTypes = {
};

export default React.memo(JobDetail);

